import React, { FC } from "react";
import { IIconProps } from "./types";
import { Icon } from "./Icon";

/**
 * Panel glyph for the sidebar collapse/expand control (SD-4167): a rounded
 * outline with a filled rail down the left edge. Stroked rather than filled so
 * it reads at 18px, and direction-neutral -- the same mark is used to collapse
 * and to expand, matching the design.
 */
export const SidebarToggleIcon: FC<IIconProps> = (props) => (
  <Icon baseWidth={18} baseHeight={18} {...props}>
    {(width, height, color) => (
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.25"
          y="2.25"
          width="15.5"
          height="13.5"
          rx="2.25"
          stroke={color}
          strokeWidth="1.5"
        />
        <path d="M6.5 2.75V15.25" stroke={color} strokeWidth="1.5" />
      </svg>
    )}
  </Icon>
);
